import React from 'react';
import store from '@carvana/purchase-store';
import { DragAndDrop, FileSelector } from '@carvana/purchase-helpers';
import * as sharedPayStubModalStyles from '../../document-wizard-modal.styles';
import * as fileUploadStyles from './document-select.styles';

const sc = { ...sharedPayStubModalStyles, ...fileUploadStyles };

const acceptableFileTypes = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/jfif',
  'image/tiff',
  'application/pdf'
];

const DocumentSelectBase = props => {
  const { document, wizardConfig, handleSelectedFile, goToStep } = props;

  const fileSelected = files => {
    const file = files[0];
    const fileTypeValid = acceptableFileTypes.indexOf(file.type) >= 0;
    if (fileTypeValid) {
      store.dispatch(handleSelectedFile({ document, selectedFile: files[0] }));
      goToStep();
    }
  };

  return (
    <DragAndDrop
      acceptableFiles={acceptableFileTypes.join(',')}
      fileDropLimit={1}
      handleDroppedFile={fileSelected}
    >
      <sc.DocumentSelectHeading>
        {wizardConfig.heading}
      </sc.DocumentSelectHeading>
      <sc.DragDropText>
        Drag your file or click the button to upload
      </sc.DragDropText>
      <sc.FileSelectorWrapper>
        <FileSelector
          handleSelectedFile={fileSelected}
          acceptableFiles={acceptableFileTypes.join(',')}
        >
          Upload
        </FileSelector>
      </sc.FileSelectorWrapper>
    </DragAndDrop>
  );
};

export default DocumentSelectBase;
